import React from 'react';

export function Join({ items, separator }: { items: React.ReactNode[]; separator: string }) {
  return (
    <>
      {items
        .filter(Boolean)
        // eslint-disable-next-line react/jsx-no-useless-fragment
        .map((item, index) => [<>{item}</>, index !== items.length - 1 && <>{separator}</>])
        .flat()}
    </>
  );
}
